export default "/images/acd05bc9c07c7eb3acac68a58e9f6d15.avif";